/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import measurments from "../../assets/images/measurments-Idntfy.png";
import SpecificButton from '../specificButton/SpecificButton';
import Header from '../header/Header';
import { HeaderType } from '../../vars';

function IdntfyHome({handleClick}) {
  return (
    <div className='text-center  h-full w-full flex flex-col'>
        <Header whatTypeHeader={HeaderType.IdntfyStore}/>
    <div className='px-4 mt-8 max-w-[300px] mx-auto'>
    <h2>Welcome to Tailored Fitting</h2>
    <p className='mt-2'>Say goodbye to size guesswork. Scan once, find your perfect fit – across every brand.</p>
    </div>
    <div className='flex items-center justify-center my-8 flex-1' >
    <img src={measurments}  alt="measurments" />
    </div>
    <div className='px-4 py-8 max-w-md mx-auto'>
    <SpecificButton buttonFunc={handleClick} className="!w-[224px]" buttonText="Start" />

<p className='mt-4  max-w-[270px] mx-auto font-headingFonts'>We’ll keep your data safe. By continuing, you agree to our <a href='#' className='underline'>privacy policy</a>.</p>
    </div>
    </div>
  )
}

export default IdntfyHome